import cx from 'classnames'
import { Field } from 'formik'
import { formatDataDate } from '~/common/dateUtils'
import styles from '~/custom_reports/v3/ReportBuilderTable.module.scss'
import { FormikDatePicker } from '~/components/v2/formik/FormikDatePicker'

// Used in reporting where we need the date value needs to be a date only string without time and timezone
export const ReportingDatePicker = ({ name, setFieldValue, isDatePickerInModal }) => {
  const className = cx(styles.ReportingDatePickerInput)

  return (
    <Field
      name={name}
      as={FormikDatePicker}
      onChangeOverride={date => setFieldValue(name, formatDataDate(date))}
      dateFormat="MMM dd yyyy"
      isInModal={isDatePickerInModal}
      className={className}
      placeholderText="Select..."
    />
  )
}
